import {
  ChangeDetectionStrategy,
  Component,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { I18nDetectorService } from '../../../../../core//services/i18n.detector.service';
import { AlertService } from '../../../../../core/services/alert.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '../../../../../shared/modules/translate/translate.service';
@Component({
  selector: 'app-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrl: './jumbotron.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JumbotronComponent {
  safeHtmlTitle = signal<SafeHtml>('');
  titleKey = 'Enjoy a seamless online experience with our free, tailor-made tools!';

  constructor(public alertService: AlertService, public i18nService: I18nDetectorService, private translateService: TranslateService,
    private sanitizer: DomSanitizer

  ) { }
  ngOnInit() {
    this.translateService.onLangChange.subscribe((translatedTitle) => {
      this.translate();
    });

    this.translate();
  }
  translate() {
    this.safeHtmlTitle.set(
      this.sanitizer.bypassSecurityTrustHtml(
        this.translateService.get(this.titleKey)
      )
    );
  }
}